import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Image } from "react-bootstrap";
import { apiGetOrgunit, apiSaveOrgunit, apiUpdateOrgunit } from "../../../api/ApiOrgunit";
import { useSelector } from "react-redux";
import { MdDeleteOutline, MdAddCircleOutline, MdDelete } from "react-icons/md";
import SwitchFrequence from "./SwitchFrequence";
import ModalCropImage from "../../layout/ModalCropImage";
import { useTranslation } from "react-i18next";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { BsDisplay } from "react-icons/bs";

const ModalCreateUpdate = (props) => {
  const { t } = useTranslation();
  const jours = [
    { indice: 1, label: t("commun.jours.lundi") },
    { indice: 2, label: t("commun.jours.mardi") },
    { indice: 3, label: t("commun.jours.mercredi") },
    { indice: 4, label: t("commun.jours.jeudi") },
    { indice: 5, label: t("commun.jours.vendredi") },
    { indice: 6, label: t("commun.jours.samedi") },
    { indice: 0, label: t("commun.jours.dimanche") },
  ];
  const joursMois = [];
  for (let i = 1; i <= 31; i++) joursMois.push({ indice: i, label: i });

  const mois = [
    { indice: 0, label: t("commun.mois.janvier") },
    { indice: 1, label: t("commun.mois.fevrier") },
    { indice: 2, label: t("commun.mois.mars") },
    { indice: 3, label: t("commun.mois.avril") },
    { indice: 4, label: t("commun.mois.mai") },
    { indice: 5, label: t("commun.mois.juin") },
    { indice: 6, label: t("commun.mois.juillet") },
    { indice: 7, label: t("commun.mois.aout") },
    { indice: 8, label: t("commun.mois.septembre") },
    { indice: 9, label: t("commun.mois.octobre") },
    { indice: 10, label: t("commun.mois.novembre") },
    { indice: 11, label: t("commun.mois.decembre") },
  ];

  const initialState = {
    nom: "",
    type: "",
    description: "",
    responsabilites: "",
    frequence: "",
    detailFrequence: [],
    scope: "Externe",
    liens: [],
    orgUnitParent: null,
    cardPic: "",
    enSommeil: false,
  };
  const { id, show, handleClose, handleRecupDatas, orgUnits, refreshDemande } = props;
  const [state, setState] = useState(initialState);
  const [forbiddenOrgunitParent, setForbiddenOrgunitParent] = useState([]);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);

  const [image, setImage] = useState("");
  const [croppedImage, setCroppedImage] = useState("");
  const [showModalCrop, setShowModalCrop] = useState(false);

  const recupData = async () => {
    const res = await apiGetOrgunit(ReduxInstance._id, id);
    if (res.data && !res.data.enSommeil) {
      res.data.enSommeil = false;
    }
    setState(res.data);
    // on va interdire l'orgunit qui a appelé la popup a etre son propre parent
    creationForbiddenParent(id);
  };

  const creationForbiddenParent = (idOrgUnitPrincipal) => {
    var forbiddenOrgunitParentTemp = [idOrgUnitPrincipal];
    addRecursiveNode(forbiddenOrgunitParentTemp, idOrgUnitPrincipal);
    setForbiddenOrgunitParent(forbiddenOrgunitParentTemp);
  };

  const addRecursiveNode = (forbiddenOrgunitParentTempParent, idOrgUnitRecherche) => {
    orgUnits
      .filter((item) => item.orgUnitParent === idOrgUnitRecherche)
      .forEach((item) => {
        forbiddenOrgunitParentTempParent.push(item._id);
        addRecursiveNode(forbiddenOrgunitParentTempParent, item._id);
      });
  };

  const submitData = async () => {
    let form_data = new FormData();

    if (id) {
      if (image) {
        form_data.append("cardPic", croppedImage);
      } else if (state.cardPic === "") {
        form_data.append("cardPic", "");
      }
      /* UPDATE FOR DATAS  */
      await apiUpdateOrgunit(id, state);
      /* UPDATE FOR IMAGE  */
      await apiUpdateOrgunit(id, form_data);
    } else {
      /* SAVE FOR DATAS  */
      const retourSave = await apiSaveOrgunit(ReduxInstance._id, state);
      if (image) {
        /* UPDATE FOR IMAGE  */
        form_data.append("cardPic", croppedImage);
        await apiUpdateOrgunit(retourSave.data._id, form_data);
      }
    }

    emptyImage();
    handleRecupDatas();
    handleClose();
  };

  const handleAddLink = () => {
    const newLiens = [...state.liens];
    newLiens.push({ icone: "generique", url: "https://" });
    setState({ ...state, liens: newLiens });
  };

  const changeUrlInput = (champObjet, indexTableau, newValeur) => {
    const stateLiensCopy = [...state.liens];
    if (champObjet === "url") {
      stateLiensCopy[indexTableau].url = newValeur;
    }
    if (champObjet === "icone") {
      stateLiensCopy[indexTableau].icone = newValeur;
    }
    if (champObjet === "nom") {
      stateLiensCopy[indexTableau].nom = newValeur;
    }
    setState({ ...state, liens: stateLiensCopy });
  };

  const deleteUrlInput = (indexTableau) => {
    const stateLiensCopy = [...state.liens];
    stateLiensCopy.splice(indexTableau, 1);
    setState({ ...state, liens: stateLiensCopy });
  };

  const addRemoveIndice = (indice) => {
    const stateFrequenceCopy = { ...state }.detailFrequence;
    const toRemove = stateFrequenceCopy.indexOf(parseInt(indice));
    if (toRemove === -1) stateFrequenceCopy.push(parseInt(indice));
    else stateFrequenceCopy.splice(toRemove, 1);
    setState({ ...state }, { detailFrequence: stateFrequenceCopy });
  };

  const onSelectedFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImage(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      setShowModalCrop(true);
    }
  };

  const handleCloseCrop = () => {
    setShowModalCrop(false);
  };

  const emptyImage = () => {
    setImage("");
    setCroppedImage("");
    setState({ ...state, cardPic: "" });
    const inputFile = document.getElementById("formBasicImage");
    if (inputFile) {
      inputFile.value = "";
    }
  };

  const handleSetCrop = (_croppedImage) => {
    // setState({ ...state, cardPic: _croppedImage })
    setCroppedImage(_croppedImage);
  };

  const toggleEnSommeil = (enSommeil) => {
    enSommeil === "true"
      ? setState({ ...state, enSommeil: true })
      : setState({ ...state, enSommeil: false });
  };

  const changeOrdre = (index, sens) => {
    const liensCopy = [...state.liens];
    const elementSauvegarde = liensCopy[index];
    if (sens === "haut") {
      if (index !== 0) {
        liensCopy[index] = liensCopy[index - 1];
        liensCopy[index - 1] = elementSauvegarde;
      }
    }
    if (sens === "bas") {
      if (index !== state.liens.length - 1) {
        liensCopy[index] = liensCopy[index + 1];
        liensCopy[index + 1] = elementSauvegarde;
      }
    }
    setState({ ...state, liens: liensCopy });
  };

  useEffect(() => {
    if (id) {
      recupData();
    } else {
      setState(initialState);
      setImage("");
      setCroppedImage("");
    }
  }, [id, refreshDemande]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {state._id
            ? t("admin.PageAdminOrgunits.modalCreateUpdateTitre2")
            : t("admin.PageAdminOrgunits.modalCreateUpdateTitre1")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <label className="mt-2">{t("commun.form.label.intitule1")}</label>
          <Form.Control
            type="text"
            name="nom"
            value={state.nom}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />

          <label className="mt-2">{t("admin.PageAdminOrgunits.titreColonne7")}</label>
          {ReduxInstance.orgunitPrincipalInOperation !== state._id ? (
            <Form.Select
              name="enSommeil"
              value={state.enSommeil}
              onChange={(e) => toggleEnSommeil(e.target.value)}
            >
              <option value="false">{t("admin.PageAdminOrgunits.titreColonne8")}</option>
              <option value="true">{t("admin.PageAdminOrgunits.titreColonne9")}</option>
            </Form.Select>
          ) : (
            <div className="text-danger">
              {t("admin.PageAdminOrgunits.modalAlerteMissionPrincipale")}
            </div>
          )}

          <label className="mt-2">{t("commun.form.label.type")}</label>
          <Form.Select
            name="type"
            value={state.type}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          >
            <option value=""></option>
            <option value="Rituel">{t("commun.form.select.rituel")}</option>
            <option value="Temps collectif">{t("commun.form.select.tempsCollectif")}</option>
            <option value="Rôle">{t("commun.form.select.role")}</option>
            <option value="Partie prenante">{t("commun.form.select.partiePrenante")}</option>
            <option value="Mission">{t("commun.form.select.mission")}</option>
          </Form.Select>
          {/* ce n'(est pas une erreur, on a renommé juste l'intitulé description en responsabilités mais en BDD c'est bien le champ description qui avait déjà était renseigné par Stéphane) */}
          <label className="mt-2">{t("commun.form.label.responsabilites")}</label>
          <Form.Control
            type="text"
            as="textarea"
            name="description"
            value={state.description}
            rows={6}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
          {/* le champ description devient donc descriptionRelle en BDD */}
          <label className="mt-2">{t("commun.form.label.description")}</label>
          <Form.Control
            type="text"
            as="textarea"
            name="descriptionReelle"
            value={state.descriptionReelle}
            rows={6}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
          <label className="mt-2"> {t("commun.form.label.frequence")}</label>
          <Form.Select
            name="frequence"
            value={state.frequence}
            onChange={(e) => {
              setState({
                ...state,
                [e.target.name]: e.target.value,
                detailFrequence: [],
              });
            }}
          >
            <option value={null}></option>
            <option value="Hebdomadaire">{t("commun.form.select.hebdomadaire")}</option>
            <option value="Mensuel">{t("commun.form.select.mensuel")}</option>
            <option value="Annuel">{t("commun.form.select.annuel")}</option>
          </Form.Select>

          {state.frequence === "Hebdomadaire" && (
            <SwitchFrequence
              boucle={jours}
              handleAddRemoveIndice={addRemoveIndice}
              frequence="Hebdomadaire"
              arrayFrequence={state.detailFrequence}
            />
          )}

          {state.frequence === "Mensuel" && (
            <SwitchFrequence
              boucle={joursMois}
              handleAddRemoveIndice={addRemoveIndice}
              frequence="Mensuel"
              arrayFrequence={state.detailFrequence}
            />
          )}

          {state.frequence === "Annuel" && (
            <SwitchFrequence
              boucle={mois}
              handleAddRemoveIndice={addRemoveIndice}
              frequence="Annuel"
              arrayFrequence={state.detailFrequence}
            />
          )}
          <label className="mt-2">{t("commun.form.label.instanceOrgunit")}</label>
          <Form.Select
            name="orgUnitParent"
            value={state.orgUnitParent == null ? "" : state.orgUnitParent}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value || null })}
          >
            <option value=""></option>
            {orgUnits
              .filter((item) => !forbiddenOrgunitParent.includes(item._id))
              .map((item) => (
                <option value={item._id} key={item._id}>
                  {item.enSommeil
                    ? "⚠ " + t("admin.PageAdminOrgunits.titreColonne9") + " ⚠ - "
                    : ""}
                  {item.nom}
                </option>
              ))}
          </Form.Select>

          <label className="mt-2">{t("commun.form.label.cible")}</label>
          <Form.Select
            name="scope"
            value={state.scope}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          >
            <option value="Interne">{t("commun.form.select.interne")}</option>
            <option value="Externe">{t("commun.form.select.externe")}</option>
          </Form.Select>
          {croppedImage ? (
            <div>
              <div className="mt-2">{t("commun.form.label.image")}</div>
              <Image src={URL.createObjectURL(croppedImage)} width={154} height={87} />
              <span role="button" onClick={() => emptyImage()}>
                <MdDelete size="1.5em" />
              </span>
            </div>
          ) : state.cardPic ? (
            <div>
              <div className="mt-2">{t("commun.form.label.image")}</div>
              <Image
                width={168}
                src={process.env.REACT_APP_URL_EXPRESS + "images/orgunit/" + state.cardPic}
              />
              <span role="button" onClick={() => emptyImage()}>
                <MdDelete size="1.5em" />
              </span>
            </div>
          ) : (
            <div>
              <label className="mt-2">{t("commun.form.label.image")}</label>
              <Form.Control type="file" accept="image/*" onChange={onSelectedFile} />
            </div>
          )}
          <div className="mt-3" role="button" onClick={() => handleAddLink()}>
            <span>{t("commun.form.label.liens")}</span>
            <span role="button">
              <MdAddCircleOutline size="1.5em" />
            </span>
          </div>
          {state.liens.length > 0 && (
            <div className="input-group mt-2">
              <Form.Control
                disabled
                defaultValue={t("commun.form.label.typeLien")}
                style={{ width: "30%" }}
              />
              <Form.Control
                disabled
                defaultValue={t("commun.form.label.nomLien")}
                style={{ width: "30%" }}
              />
              <Form.Control
                disabled
                defaultValue={t("commun.form.label.urlLien")}
                style={{ width: "40%" }}
              />
            </div>
          )}
          {state.liens.map((lien, index) => (
            <div className="input-group mt-2" key={index}>
              <div style={{ width: "30%", display: "flex" }}>
                <div>
                  <TiArrowSortedUp
                    size="1em"
                    role="button"
                    onClick={(e) => changeOrdre(index, "haut")}
                  />
                  <TiArrowSortedDown
                    size="1em"
                    role="button"
                    onClick={(e) => changeOrdre(index, "bas")}
                  />
                </div>
                <Form.Select
                  key={"icone" + index}
                  name="icone"
                  value={lien.icone}
                  onChange={(e) => changeUrlInput(e.target.name, index, e.target.value)}
                >
                  <option value="generique">{t("commun.form.select.generique")}</option>
                  <option value="sharepoint">Sharepoint</option>
                  <option value="powerbi">Power BI</option>
                  <option value="onenote">One Note</option>
                  <option value="colidee">Colidée</option>
                  <option value="teams">Teams</option>
                  <option value="word">Word</option>
                  <option value="excel">Excel</option>
                  <option value="powerpoint">Powerpoint</option>
                  <option value="pdf">PDF</option>
                  <option value="missions">Entreprise à missions</option>
                </Form.Select>
              </div>
              <Form.Control
                key={"nom" + index}
                name="nom"
                type="text"
                value={lien.nom ?? ""}
                style={{ width: "30%" }}
                onChange={(e) => changeUrlInput(e.target.name, index, e.target.value)}
              />
              <Form.Control
                key={"url" + index}
                name="url"
                type="text"
                value={lien.url}
                style={{ width: "30%" }}
                onChange={(e) => changeUrlInput(e.target.name, index, e.target.value)}
              />
              <Button
                variant="danger"
                onClick={() => deleteUrlInput(index)}
                style={{ width: "10%" }}
              >
                <MdDeleteOutline size="1.2em" />
              </Button>
            </div>
          ))}
        </Form>

        <ModalCropImage
          show={showModalCrop}
          image={image}
          handleClose={handleCloseCrop}
          resetImage={emptyImage}
          setImageCropped={handleSetCrop}
          xRatio={154}
          yRatio={87}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitData}>
          {state._id ? t("commun.form.button.modifier") : t("commun.form.button.ajouter")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCreateUpdate;
